import { lazy } from "react";

export const Mockup = lazy(() => import("./Mockup.jsx"));
export const VerifyAccount = lazy(() => import("./VerifyAccount"));
export const Authentication = lazy(() => import("./Authentication"));
export const RoleHandler = lazy(() => import("./RoleHandler"));
export const CompetencyMapping = lazy(() => import("./CompetencyMapping.jsx"));
export const CompetencyLearning = lazy(() =>
  import("./CompetencyLearning.jsx")
);

export { default as Loading } from "./Loading";
